import { patchRequest, postRequest, getRequest } from 'apis/ApiInstence';
import { put } from 'redux-saga/effects';
import { successChemical, failedChemical } from 'slice/chemicalSlice';


export function* updateChemicalAPI({ payload }) {
  try {
    let header = {
      headers: { "Content-Type": "multipart/form-data" }
    }
    yield patchRequest(`chemical/${payload.id}`, payload.data, header);
    const response = yield getRequest('chemical');
    if (response?.status == 200) {
      yield put(successChemical(response?.data));
    } else {
      yield put(failedChemical(response));
    }
  } catch (error) {
    console.log(error)
  }
}

export function* addChemicalFun({ payload }) {
  try {
    const response = yield postRequest(`chemical`, payload);
    if (response?.status == 201) {
      const list = yield getRequest('chemical');
      yield put(successChemical(list?.data));
    } else {
      yield put(failedChemical(response));
    }
  } catch (error) {
    console.log(error)
  }
}

export function* getChemicalFun() {
  try {
    const response = yield getRequest('chemical');
    if (response?.status == 200) {
      yield put(successChemical(response?.data));
    } else {
      yield put(failedChemical(response));
    }
  } catch (error) {
    console.log(error)
  }
}
